import React from 'react';
import PropTypes from 'prop-types';

import TelemetryContext from '@zr/components/context/TelemetryContext';
import EmployerScreeningQuestionsApp from '@zr/jobseeker-public/apps/jobseeker/screening-questions/EmployerScreeningQuestionsAppV1';

import useTelemetry from './telemetry';
import { applyDataPropTypes } from '../../../applyFlowPropTypes';
import { employerScreeningQuestionsPropTypes } from '../../../screenTypeSchema';

export function EmployerScreeningQuestions({ applyData, screenTypeParameters, onScreenTypeFinish, setIsLoading }) {
  const { enc_response_id: encResponseId } = screenTypeParameters;
  const { logView, logInteraction, logFinish } = useTelemetry(applyData);
  const { is_mobile: isMobile } = applyData;

  const handleScreenTypeFinish = () => {
    logFinish();
    onScreenTypeFinish();
  };

  return (
    <TelemetryContext.Provider value={{ logInteraction, logView }}>
      <EmployerScreeningQuestionsApp
        encResponseId={encResponseId}
        isMobile={isMobile}
        onCompleted={handleScreenTypeFinish}
        setIsLoading={setIsLoading}
      />
    </TelemetryContext.Provider>
  );
}

EmployerScreeningQuestions.propTypes = {
  applyData: applyDataPropTypes.isRequired,
  onScreenTypeFinish: PropTypes.func.isRequired,
  screenTypeParameters: employerScreeningQuestionsPropTypes.isRequired,
  setIsLoading: PropTypes.func,
};

EmployerScreeningQuestions.defaultProps = {
  setIsLoading: () => {},
};

export default EmployerScreeningQuestions;
